export default function FlowIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9987 16.9167C1.38786 16.9167 0.0820312 15.6109 0.0820312 14C0.0820312 12.3892 1.38786 11.0834 2.9987 11.0834C4.31953 11.0834 5.43536 11.9617 5.79453 13.1667H10.4987V11.5H12.1654V6.70171L10.2962 4.83338H5.4987V6.50005H0.498698V1.50005H5.4987V3.16671H10.2962L12.9987 0.463379L16.5345 4.00005L13.832 6.70088V11.5H15.4987V16.5H10.4987V14.8334H5.79453C5.4362 16.0384 4.31953 16.9167 2.9987 16.9167ZM2.9987 12.75C2.3087 12.75 1.7487 13.31 1.7487 14C1.7487 14.69 2.3087 15.25 2.9987 15.25C3.6887 15.25 4.2487 14.69 4.2487 14C4.2487 13.31 3.6887 12.75 2.9987 12.75ZM13.832 13.1667H12.1654V14.8334H13.832V13.1667ZM12.9987 2.82171L11.8204 4.00005L12.9987 5.17838L14.177 4.00005L12.9987 2.82171ZM3.83203 3.16671H2.16536V4.83338H3.83203V3.16671Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
